import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZapierComponent } from './simple-icons-zapier.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZapierComponent ],
    exports:      [ SimpleIconsZapierComponent ],
    bootstrap:    []
})
export class SimpleIconsZapierModule {}
